import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
export var foregroundColor = 'white';

if (typeof foregroundColor !== 'undefined' && foregroundColor && foregroundColor === Object(foregroundColor) && Object.isExtensible(foregroundColor) && !foregroundColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(foregroundColor, '__filemeta', {
    configurable: true,
    value: {
      name: "foregroundColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var backgroundColor = '#f2F4f5';

if (typeof backgroundColor !== 'undefined' && backgroundColor && backgroundColor === Object(backgroundColor) && Object.isExtensible(backgroundColor) && !backgroundColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(backgroundColor, '__filemeta', {
    configurable: true,
    value: {
      name: "backgroundColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var separatorColor = '#f2F4f5';

if (typeof separatorColor !== 'undefined' && separatorColor && separatorColor === Object(separatorColor) && Object.isExtensible(separatorColor) && !separatorColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(separatorColor, '__filemeta', {
    configurable: true,
    value: {
      name: "separatorColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var processedColor = '#a7e0a3';

if (typeof processedColor !== 'undefined' && processedColor && processedColor === Object(processedColor) && Object.isExtensible(processedColor) && !processedColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(processedColor, '__filemeta', {
    configurable: true,
    value: {
      name: "processedColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var processingColor = '#ffce5c';

if (typeof processingColor !== 'undefined' && processingColor && processingColor === Object(processingColor) && Object.isExtensible(processingColor) && !processingColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(processingColor, '__filemeta', {
    configurable: true,
    value: {
      name: "processingColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var failedColor = '#f67e7e';

if (typeof failedColor !== 'undefined' && failedColor && failedColor === Object(failedColor) && Object.isExtensible(failedColor) && !failedColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(failedColor, '__filemeta', {
    configurable: true,
    value: {
      name: "failedColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var textSecondaryColor = '#7a92a5';

if (typeof textSecondaryColor !== 'undefined' && textSecondaryColor && textSecondaryColor === Object(textSecondaryColor) && Object.isExtensible(textSecondaryColor) && !textSecondaryColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(textSecondaryColor, '__filemeta', {
    configurable: true,
    value: {
      name: "textSecondaryColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var textDefaultColor = '#2d4150';

if (typeof textDefaultColor !== 'undefined' && textDefaultColor && textDefaultColor === Object(textDefaultColor) && Object.isExtensible(textDefaultColor) && !textDefaultColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(textDefaultColor, '__filemeta', {
    configurable: true,
    value: {
      name: "textDefaultColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var textColor = '#43515c';

if (typeof textColor !== 'undefined' && textColor && textColor === Object(textColor) && Object.isExtensible(textColor) && !textColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(textColor, '__filemeta', {
    configurable: true,
    value: {
      name: "textColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var textLinkColor = '#00BBF2';

if (typeof textLinkColor !== 'undefined' && textLinkColor && textLinkColor === Object(textLinkColor) && Object.isExtensible(textLinkColor) && !textLinkColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(textLinkColor, '__filemeta', {
    configurable: true,
    value: {
      name: "textLinkColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var textDayFontFamily = 'System';

if (typeof textDayFontFamily !== 'undefined' && textDayFontFamily && textDayFontFamily === Object(textDayFontFamily) && Object.isExtensible(textDayFontFamily) && !textDayFontFamily.hasOwnProperty('__filemeta')) {
  Object.defineProperty(textDayFontFamily, '__filemeta', {
    configurable: true,
    value: {
      name: "textDayFontFamily",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var textMonthFontFamily = 'System';

if (typeof textMonthFontFamily !== 'undefined' && textMonthFontFamily && textMonthFontFamily === Object(textMonthFontFamily) && Object.isExtensible(textMonthFontFamily) && !textMonthFontFamily.hasOwnProperty('__filemeta')) {
  Object.defineProperty(textMonthFontFamily, '__filemeta', {
    configurable: true,
    value: {
      name: "textMonthFontFamily",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var textDayHeaderFontFamily = 'System';

if (typeof textDayHeaderFontFamily !== 'undefined' && textDayHeaderFontFamily && textDayHeaderFontFamily === Object(textDayHeaderFontFamily) && Object.isExtensible(textDayHeaderFontFamily) && !textDayHeaderFontFamily.hasOwnProperty('__filemeta')) {
  Object.defineProperty(textDayHeaderFontFamily, '__filemeta', {
    configurable: true,
    value: {
      name: "textDayHeaderFontFamily",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var todayButtonFontFamily = 'System';

if (typeof todayButtonFontFamily !== 'undefined' && todayButtonFontFamily && todayButtonFontFamily === Object(todayButtonFontFamily) && Object.isExtensible(todayButtonFontFamily) && !todayButtonFontFamily.hasOwnProperty('__filemeta')) {
  Object.defineProperty(todayButtonFontFamily, '__filemeta', {
    configurable: true,
    value: {
      name: "todayButtonFontFamily",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var textDayFontWeight = '300';

if (typeof textDayFontWeight !== 'undefined' && textDayFontWeight && textDayFontWeight === Object(textDayFontWeight) && Object.isExtensible(textDayFontWeight) && !textDayFontWeight.hasOwnProperty('__filemeta')) {
  Object.defineProperty(textDayFontWeight, '__filemeta', {
    configurable: true,
    value: {
      name: "textDayFontWeight",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var textMonthFontWeight = '300';

if (typeof textMonthFontWeight !== 'undefined' && textMonthFontWeight && textMonthFontWeight === Object(textMonthFontWeight) && Object.isExtensible(textMonthFontWeight) && !textMonthFontWeight.hasOwnProperty('__filemeta')) {
  Object.defineProperty(textMonthFontWeight, '__filemeta', {
    configurable: true,
    value: {
      name: "textMonthFontWeight",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var textDayHeaderFontWeight = undefined;

if (typeof textDayHeaderFontWeight !== 'undefined' && textDayHeaderFontWeight && textDayHeaderFontWeight === Object(textDayHeaderFontWeight) && Object.isExtensible(textDayHeaderFontWeight) && !textDayHeaderFontWeight.hasOwnProperty('__filemeta')) {
  Object.defineProperty(textDayHeaderFontWeight, '__filemeta', {
    configurable: true,
    value: {
      name: "textDayHeaderFontWeight",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var todayButtonFontWeight = '600';

if (typeof todayButtonFontWeight !== 'undefined' && todayButtonFontWeight && todayButtonFontWeight === Object(todayButtonFontWeight) && Object.isExtensible(todayButtonFontWeight) && !todayButtonFontWeight.hasOwnProperty('__filemeta')) {
  Object.defineProperty(todayButtonFontWeight, '__filemeta', {
    configurable: true,
    value: {
      name: "todayButtonFontWeight",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var textDayFontSize = 16;

if (typeof textDayFontSize !== 'undefined' && textDayFontSize && textDayFontSize === Object(textDayFontSize) && Object.isExtensible(textDayFontSize) && !textDayFontSize.hasOwnProperty('__filemeta')) {
  Object.defineProperty(textDayFontSize, '__filemeta', {
    configurable: true,
    value: {
      name: "textDayFontSize",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var textMonthFontSize = 16;

if (typeof textMonthFontSize !== 'undefined' && textMonthFontSize && textMonthFontSize === Object(textMonthFontSize) && Object.isExtensible(textMonthFontSize) && !textMonthFontSize.hasOwnProperty('__filemeta')) {
  Object.defineProperty(textMonthFontSize, '__filemeta', {
    configurable: true,
    value: {
      name: "textMonthFontSize",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var textDayHeaderFontSize = 13;

if (typeof textDayHeaderFontSize !== 'undefined' && textDayHeaderFontSize && textDayHeaderFontSize === Object(textDayHeaderFontSize) && Object.isExtensible(textDayHeaderFontSize) && !textDayHeaderFontSize.hasOwnProperty('__filemeta')) {
  Object.defineProperty(textDayHeaderFontSize, '__filemeta', {
    configurable: true,
    value: {
      name: "textDayHeaderFontSize",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var todayButtonFontSize = 14;

if (typeof todayButtonFontSize !== 'undefined' && todayButtonFontSize && todayButtonFontSize === Object(todayButtonFontSize) && Object.isExtensible(todayButtonFontSize) && !todayButtonFontSize.hasOwnProperty('__filemeta')) {
  Object.defineProperty(todayButtonFontSize, '__filemeta', {
    configurable: true,
    value: {
      name: "todayButtonFontSize",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var textDayStyle = undefined;

if (typeof textDayStyle !== 'undefined' && textDayStyle && textDayStyle === Object(textDayStyle) && Object.isExtensible(textDayStyle) && !textDayStyle.hasOwnProperty('__filemeta')) {
  Object.defineProperty(textDayStyle, '__filemeta', {
    configurable: true,
    value: {
      name: "textDayStyle",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var dotStyle = undefined;

if (typeof dotStyle !== 'undefined' && dotStyle && dotStyle === Object(dotStyle) && Object.isExtensible(dotStyle) && !dotStyle.hasOwnProperty('__filemeta')) {
  Object.defineProperty(dotStyle, '__filemeta', {
    configurable: true,
    value: {
      name: "dotStyle",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var arrowStyle = undefined;

if (typeof arrowStyle !== 'undefined' && arrowStyle && arrowStyle === Object(arrowStyle) && Object.isExtensible(arrowStyle) && !arrowStyle.hasOwnProperty('__filemeta')) {
  Object.defineProperty(arrowStyle, '__filemeta', {
    configurable: true,
    value: {
      name: "arrowStyle",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var calendarBackground = foregroundColor;

if (typeof calendarBackground !== 'undefined' && calendarBackground && calendarBackground === Object(calendarBackground) && Object.isExtensible(calendarBackground) && !calendarBackground.hasOwnProperty('__filemeta')) {
  Object.defineProperty(calendarBackground, '__filemeta', {
    configurable: true,
    value: {
      name: "calendarBackground",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var textSectionTitleColor = '#b6c1cd';

if (typeof textSectionTitleColor !== 'undefined' && textSectionTitleColor && textSectionTitleColor === Object(textSectionTitleColor) && Object.isExtensible(textSectionTitleColor) && !textSectionTitleColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(textSectionTitleColor, '__filemeta', {
    configurable: true,
    value: {
      name: "textSectionTitleColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var textSectionTitleDisabledColor = '#d9e1e8';

if (typeof textSectionTitleDisabledColor !== 'undefined' && textSectionTitleDisabledColor && textSectionTitleDisabledColor === Object(textSectionTitleDisabledColor) && Object.isExtensible(textSectionTitleDisabledColor) && !textSectionTitleDisabledColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(textSectionTitleDisabledColor, '__filemeta', {
    configurable: true,
    value: {
      name: "textSectionTitleDisabledColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var selectedDayBackgroundColor = textLinkColor;

if (typeof selectedDayBackgroundColor !== 'undefined' && selectedDayBackgroundColor && selectedDayBackgroundColor === Object(selectedDayBackgroundColor) && Object.isExtensible(selectedDayBackgroundColor) && !selectedDayBackgroundColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(selectedDayBackgroundColor, '__filemeta', {
    configurable: true,
    value: {
      name: "selectedDayBackgroundColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var selectedDayTextColor = foregroundColor;

if (typeof selectedDayTextColor !== 'undefined' && selectedDayTextColor && selectedDayTextColor === Object(selectedDayTextColor) && Object.isExtensible(selectedDayTextColor) && !selectedDayTextColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(selectedDayTextColor, '__filemeta', {
    configurable: true,
    value: {
      name: "selectedDayTextColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var todayBackgroundColor = undefined;

if (typeof todayBackgroundColor !== 'undefined' && todayBackgroundColor && todayBackgroundColor === Object(todayBackgroundColor) && Object.isExtensible(todayBackgroundColor) && !todayBackgroundColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(todayBackgroundColor, '__filemeta', {
    configurable: true,
    value: {
      name: "todayBackgroundColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var todayTextColor = textLinkColor;

if (typeof todayTextColor !== 'undefined' && todayTextColor && todayTextColor === Object(todayTextColor) && Object.isExtensible(todayTextColor) && !todayTextColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(todayTextColor, '__filemeta', {
    configurable: true,
    value: {
      name: "todayTextColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var dayTextColor = textDefaultColor;

if (typeof dayTextColor !== 'undefined' && dayTextColor && dayTextColor === Object(dayTextColor) && Object.isExtensible(dayTextColor) && !dayTextColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(dayTextColor, '__filemeta', {
    configurable: true,
    value: {
      name: "dayTextColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var textDisabledColor = '#d9e1e8';

if (typeof textDisabledColor !== 'undefined' && textDisabledColor && textDisabledColor === Object(textDisabledColor) && Object.isExtensible(textDisabledColor) && !textDisabledColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(textDisabledColor, '__filemeta', {
    configurable: true,
    value: {
      name: "textDisabledColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var dotColor = textLinkColor;

if (typeof dotColor !== 'undefined' && dotColor && dotColor === Object(dotColor) && Object.isExtensible(dotColor) && !dotColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(dotColor, '__filemeta', {
    configurable: true,
    value: {
      name: "dotColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var selectedDotColor = foregroundColor;

if (typeof selectedDotColor !== 'undefined' && selectedDotColor && selectedDotColor === Object(selectedDotColor) && Object.isExtensible(selectedDotColor) && !selectedDotColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(selectedDotColor, '__filemeta', {
    configurable: true,
    value: {
      name: "selectedDotColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var disabledDotColor = undefined;

if (typeof disabledDotColor !== 'undefined' && disabledDotColor && disabledDotColor === Object(disabledDotColor) && Object.isExtensible(disabledDotColor) && !disabledDotColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(disabledDotColor, '__filemeta', {
    configurable: true,
    value: {
      name: "disabledDotColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var todayDotColor = undefined;

if (typeof todayDotColor !== 'undefined' && todayDotColor && todayDotColor === Object(todayDotColor) && Object.isExtensible(todayDotColor) && !todayDotColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(todayDotColor, '__filemeta', {
    configurable: true,
    value: {
      name: "todayDotColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var arrowColor = textLinkColor;

if (typeof arrowColor !== 'undefined' && arrowColor && arrowColor === Object(arrowColor) && Object.isExtensible(arrowColor) && !arrowColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(arrowColor, '__filemeta', {
    configurable: true,
    value: {
      name: "arrowColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var disabledArrowColor = '#d9e1e8';

if (typeof disabledArrowColor !== 'undefined' && disabledArrowColor && disabledArrowColor === Object(disabledArrowColor) && Object.isExtensible(disabledArrowColor) && !disabledArrowColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(disabledArrowColor, '__filemeta', {
    configurable: true,
    value: {
      name: "disabledArrowColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var monthTextColor = textDefaultColor;

if (typeof monthTextColor !== 'undefined' && monthTextColor && monthTextColor === Object(monthTextColor) && Object.isExtensible(monthTextColor) && !monthTextColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(monthTextColor, '__filemeta', {
    configurable: true,
    value: {
      name: "monthTextColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var indicatorColor = undefined;

if (typeof indicatorColor !== 'undefined' && indicatorColor && indicatorColor === Object(indicatorColor) && Object.isExtensible(indicatorColor) && !indicatorColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(indicatorColor, '__filemeta', {
    configurable: true,
    value: {
      name: "indicatorColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var agendaDayTextColor = '#7a92a5';

if (typeof agendaDayTextColor !== 'undefined' && agendaDayTextColor && agendaDayTextColor === Object(agendaDayTextColor) && Object.isExtensible(agendaDayTextColor) && !agendaDayTextColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(agendaDayTextColor, '__filemeta', {
    configurable: true,
    value: {
      name: "agendaDayTextColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var agendaDayNumColor = '#7a92a5';

if (typeof agendaDayNumColor !== 'undefined' && agendaDayNumColor && agendaDayNumColor === Object(agendaDayNumColor) && Object.isExtensible(agendaDayNumColor) && !agendaDayNumColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(agendaDayNumColor, '__filemeta', {
    configurable: true,
    value: {
      name: "agendaDayNumColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var agendaTodayColor = textLinkColor;

if (typeof agendaTodayColor !== 'undefined' && agendaTodayColor && agendaTodayColor === Object(agendaTodayColor) && Object.isExtensible(agendaTodayColor) && !agendaTodayColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(agendaTodayColor, '__filemeta', {
    configurable: true,
    value: {
      name: "agendaTodayColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var agendaKnobColor = '#f2F4f5';

if (typeof agendaKnobColor !== 'undefined' && agendaKnobColor && agendaKnobColor === Object(agendaKnobColor) && Object.isExtensible(agendaKnobColor) && !agendaKnobColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(agendaKnobColor, '__filemeta', {
    configurable: true,
    value: {
      name: "agendaKnobColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var todayButtonTextColor = textLinkColor;

if (typeof todayButtonTextColor !== 'undefined' && todayButtonTextColor && todayButtonTextColor === Object(todayButtonTextColor) && Object.isExtensible(todayButtonTextColor) && !todayButtonTextColor.hasOwnProperty('__filemeta')) {
  Object.defineProperty(todayButtonTextColor, '__filemeta', {
    configurable: true,
    value: {
      name: "todayButtonTextColor",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}

export var todayButtonPosition = undefined;

if (typeof todayButtonPosition !== 'undefined' && todayButtonPosition && todayButtonPosition === Object(todayButtonPosition) && Object.isExtensible(todayButtonPosition) && !todayButtonPosition.hasOwnProperty('__filemeta')) {
  Object.defineProperty(todayButtonPosition, '__filemeta', {
    configurable: true,
    value: {
      name: "todayButtonPosition",
      filename: "node_modules/react-native-calendars/src/style.js"
    }
  });
}